import { Suspense, lazy } from 'react';
const Loading = <div>Loading....</div>;
const CurriculumReqGuidePage = lazy(() => import('../pages/curriculum/CurriculumReqGuidePage'));
const CurriculumApplyPage = lazy(() => import('../pages/curriculum/CurriculumApplyPage'));
const CurriculumDetailPage = lazy(() => import('../pages/curriculum/CurriculumDetailPage'));
const CurriculumPaymentPage = lazy(() => import('../pages/curriculum/CurriculumPaymentPage'));

const curriculumRouter = () => {
  return [
    {
      path: 'guide',
      element: (
        <Suspense fallback={Loading}>
          <CurriculumReqGuidePage />
        </Suspense>
      ),
      
      
    },
    {
      path: 'scheduleAndApply',
      element: (
        <Suspense fallback={Loading}>
          <CurriculumApplyPage />
        </Suspense>
      ),
    },
    {
      path: 'detail',
      element: (
        <Suspense fallback={Loading}>
          <CurriculumDetailPage />
        </Suspense>
      ),
    },
    {
      path: 'payment',
      element: (
        <Suspense fallback={Loading}>
          <CurriculumPaymentPage />
        </Suspense>
      ),
    },
    // {
    //   path: 'register-form/:memberType',
    //   element: (
    //     <Suspense fallback={Loading}>
    //       <RegisterForm />
    //     </Suspense>
    //   ),
    // },
  ];
};

export default curriculumRouter;
